import { FlexBox, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { StatsScreenshotLogo } from './StatsScreenshotLogo'

export const StatsScreenshotFooter = () => {
  const { colors } = useTheme()

  return (
    <FlexBox
      className={css`
        padding: 0 16px;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 40px;
        background-color: ${colors.uiBlack60};
        z-index: 2;
      `}
      justifyContent="space-between"
      alignItems="center"
    >
      <StatsScreenshotLogo />
      <Text
        className={css`
          width: 100%;
          max-width: 176px;
          font-size: 12px;
          line-height: 12px;
          letter-spacing: -0.2px;
          font-weight: 600;
        `}
        type="body"
        align="right"
        color={colors.uiWhite}
      >
        Set goals and discover your own reader insights on Fable
      </Text>
    </FlexBox>
  )
}
